/*
  Gentsy winkelwagen-lade (vervangt de app "AMP Slide Cart").
  - Vangt "In winkelwagen"-formulieren en links naar /cart af en opent de lade.
  - Merkt ook toevoegingen van andere scripts op (PageFly, shop the look) via fetch/XHR.
  - Rendert de inhoud opnieuw via de Section Rendering API (sections/gentsy-cart.liquid).
  - window.SLIDECART_OPEN / SLIDECART_UPDATE blijven bestaan voor bestaande code.
*/
(function () {
  // Niet window.GentsyCart: dat is automatisch het element met id="GentsyCart"
  if (window.__gentsyCartLoaded) return;
  window.__gentsyCartLoaded = true;

  var SECTION = 'gentsy-cart';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var internal = 0; // > 0 terwijl de lade zelf een verzoek doet
  var refreshTimer = null;
  var lastFocus = null;

  function drawer() { return document.getElementById('GentsyCart'); }
  function content() { return document.getElementById('GentsyCartContent'); }

  function isCartAddUrl(url) { return /\/cart\/add(\.js)?(\?|$)/.test(url); }
  function isCartChangeUrl(url) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url); }

  /* ---------- verzoeken ---------- */

  function request(path, body) {
    internal++;
    var opts = { method: body ? 'POST' : 'GET', headers: { Accept: 'application/json' } };
    if (body) opts.body = body;
    return fetch(root + path, opts)
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            var err = new Error(data.description || data.message || 'Error');
            err.data = data;
            throw err;
          }
          return data;
        });
      })
      .finally(function () { internal--; });
  }

  function withSections(form) {
    form.append('sections', SECTION);
    form.append('sections_url', window.location.pathname);
    return form;
  }

  /* ---------- weergave ---------- */

  function shipProgress(el) {
    var ship = el && el.querySelector('[data-gc-ship]');
    return ship ? ship.style.getPropertyValue('--gc-progress') : null;
  }

  function render(html) {
    var current = content();
    if (!current || !html) return;
    var next = new DOMParser().parseFromString(html, 'text/html').getElementById('GentsyCartContent');
    if (!next) return;

    var wasReached = current.dataset.gcReached === 'true';
    var oldProgress = shipProgress(current);
    var scroll = current.querySelector('.gc__body');
    var scrollTop = scroll ? scroll.scrollTop : 0;

    current.innerHTML = next.innerHTML;
    current.dataset.gcCount = next.dataset.gcCount;
    current.dataset.gcReached = next.dataset.gcReached;

    var newScroll = current.querySelector('.gc__body');
    if (newScroll) newScroll.scrollTop = scrollTop;

    // Balk vanaf de oude stand laten doorlopen naar de nieuwe
    var ship = current.querySelector('[data-gc-ship]');
    if (ship && oldProgress !== null) {
      var target = ship.style.getPropertyValue('--gc-progress');
      ship.style.setProperty('--gc-progress', oldProgress);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { ship.style.setProperty('--gc-progress', target); });
      });
      if (!wasReached && next.dataset.gcReached === 'true') ship.classList.add('gc-ship--celebrate');
    }

    syncCount(Number(next.dataset.gcCount || 0));
    if (window.GentsyDelivery) window.GentsyDelivery.update();
    setupContent();
  }

  function syncCount(count) {
    document.querySelectorAll('[data-cart-button-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.classList.toggle('hidden', count === 0);
    });
  }

  function showError(message) {
    var el = content() && content().querySelector('[data-gc-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(showError.t);
    showError.t = setTimeout(function () { el.hidden = true; }, 6000);
  }

  function refresh() {
    internal++;
    return fetch(root + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) { render(data[SECTION]); })
      .catch(function (e) { console.error('[gentsy-cart]', e); })
      .finally(function () { internal--; });
  }

  function scheduleRefresh(andOpen) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refresh().then(function () { if (andOpen) open(); });
    }, 120);
  }

  function setBusy(on) {
    var el = drawer();
    if (el) el.classList.toggle('gc--busy', on);
  }

  /* ---------- openen / sluiten ---------- */

  function open() {
    var el = drawer();
    if (!el || el.hasAttribute('open')) return;
    lastFocus = document.activeElement;
    el.setAttribute('open', '');
    document.documentElement.classList.add('gc-lock');
    var panel = el.querySelector('.gc__panel');
    setTimeout(function () { panel && panel.focus({ preventScroll: true }); }, 50);
    startUsps();
    loadRecs();
    requestAnimationFrame(updateArrows);
  }

  function close() {
    var el = drawer();
    if (!el || !el.hasAttribute('open')) return;
    el.removeAttribute('open');
    document.documentElement.classList.remove('gc-lock');
    stopUsps();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('gentsy:cart:closed'));
  }

  /* ---------- roterende USP's ---------- */

  var uspTimer = null;
  function startUsps() {
    stopUsps();
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    uspTimer = setInterval(function () {
      var wrap = content() && content().querySelector('[data-gc-usps]');
      if (!wrap) return;
      var items = wrap.children;
      var active = 0;
      for (var i = 0; i < items.length; i++) if (items[i].classList.contains('is-active')) active = i;
      items[active].classList.remove('is-active');
      items[(active + 1) % items.length].classList.add('is-active');
    }, 4500);
  }
  function stopUsps() { clearInterval(uspTimer); }

  /* ---------- acties in de lade ---------- */

  function changeLine(line, quantity) {
    var body = withSections(new FormData());
    body.append('line', line);
    body.append('quantity', Math.max(0, quantity));
    setBusy(true);
    return request('cart/change.js', body)
      .then(function (cart) { render(cart.sections && cart.sections[SECTION]); publishUpdate(cart); })
      .catch(function (e) { refresh().then(function () { showError(e.message); }); })
      .finally(function () { setBusy(false); });
  }

  function addVariant(id, button) {
    var body = withSections(new FormData());
    body.append('id', id);
    body.append('quantity', 1);
    if (button) button.classList.add('is-loading');
    setBusy(true);
    return request('cart/add.js', body)
      .then(function (item) { render(item.sections && item.sections[SECTION]); publishUpdate(item); })
      .catch(function (e) { showError(e.message); })
      .finally(function () {
        if (button) button.classList.remove('is-loading');
        setBusy(false);
      });
  }

  function publishUpdate(data) {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gentsy-cart', cartData: data }); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('gentsy:cart:updated', { detail: data }));
  }

  /* ---------- aanbevelingen (als er geen vast koppel is) ---------- */

  var recsCache = {};
  function loadRecs() {
    var holder = content() && content().querySelector('[data-gc-recs]');
    if (!holder) return;
    var productId = holder.dataset.gcRecs;
    if (recsCache[productId] !== undefined) return fillRecs(holder, recsCache[productId]);

    var url = root + 'recommendations/products?section_id=gentsy-cart-recs&limit=10&product_id=' + productId;
    function get(intent) {
      return fetch(url + '&intent=' + intent).then(function (r) { return r.ok ? r.text() : ''; });
    }
    get('complementary')
      .then(function (html) { return hasCards(html) ? html : get('related'); })
      .then(function (html) {
        recsCache[productId] = hasCards(html) ? html : '';
        var current = content() && content().querySelector('[data-gc-recs="' + productId + '"]');
        if (current) fillRecs(current, recsCache[productId]);
      })
      .catch(function () {});
  }
  function hasCards(html) { return html && html.indexOf('data-gc-upsell') > -1; }
  function fillRecs(holder, html) {
    if (!html) return;
    var track = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gc-track]');
    if (!track) return;
    holder.innerHTML =
      '<div class="gc-upsells__head"><p class="gc-upsells__title"></p><div class="gc-upsells__arrows">' +
      '<button type="button" data-gc-scroll="-1"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.4" fill="none"/></svg></button>' +
      '<button type="button" data-gc-scroll="1"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.4" fill="none"/></svg></button>' +
      '</div></div>';
    holder.querySelector('.gc-upsells__title').textContent = holder.dataset.gcRecsTitle;
    var arrows = holder.querySelectorAll('[data-gc-scroll]');
    arrows[0].setAttribute('aria-label', holder.dataset.gcPrev);
    arrows[1].setAttribute('aria-label', holder.dataset.gcNext);
    holder.appendChild(document.importNode(track, true));
    holder.classList.toggle('gc-upsells--single', track.children.length === 1);
    holder.hidden = false;
    updateArrows();
  }

  function updateArrows() {
    var root_ = content();
    if (!root_) return;
    root_.querySelectorAll('.gc-upsells').forEach(function (wrap) {
      var track = wrap.querySelector('[data-gc-track]');
      if (!track) return;
      var prev = wrap.querySelector('[data-gc-scroll="-1"]');
      var next = wrap.querySelector('[data-gc-scroll="1"]');
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      wrap.classList.toggle('gc-upsells--static', max <= 0 || wrap.classList.contains('gc-upsells--single'));
      if (!track.dataset.gcBound) {
        track.dataset.gcBound = '1';
        track.addEventListener('scroll', function () {
          clearTimeout(track._t);
          track._t = setTimeout(updateArrows, 60);
        }, { passive: true });
      }
    });
  }

  function setupContent() {
    // Aanbevelingen pas ophalen als de lade echt open is (scheelt een verzoek per pagina)
    if (drawer() && drawer().hasAttribute('open')) loadRecs();
    updateArrows();
    var ship = content() && content().querySelector('.gc-ship--celebrate');
    if (ship) setTimeout(function () { ship.classList.remove('gc-ship--celebrate'); }, 1600);
  }

  /* ---------- events ---------- */

  /* ---------- snel toevoegen op productkaarten ---------- */

  function closeQuickAdd(gq) {
    gq.classList.remove('is-open');
    var toggle = gq.querySelector('[data-gq-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-gq-toggle]');
    var openOnes = document.querySelectorAll('[data-gq].is-open');
    openOnes.forEach(function (gq) { if (!gq.contains(e.target)) closeQuickAdd(gq); });
    if (!toggle) return;
    e.preventDefault();
    e.stopPropagation();
    var gq = toggle.closest('[data-gq]');
    var willOpen = !gq.classList.contains('is-open');
    gq.classList.toggle('is-open', willOpen);
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-gc-close]')) { e.preventDefault(); close(); return; }

    var qty = t.closest('[data-gc-qty]');
    if (qty && drawer() && drawer().contains(qty)) {
      e.preventDefault();
      var line = qty.closest('[data-gc-line]');
      changeLine(line.dataset.gcLine, Number(qty.dataset.gcQty));
      return;
    }

    var add = t.closest('[data-gc-upsell-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('[data-gc-upsell]');
      var variant = card && card.querySelector('[data-gc-upsell-variant]');
      if (variant && variant.value) addVariant(variant.value, add);
      return;
    }

    var arrow = t.closest('[data-gc-scroll]');
    if (arrow) {
      var track = arrow.closest('.gc-upsells').querySelector('[data-gc-track]');
      var card_ = track && track.firstElementChild;
      var step = card_ ? card_.getBoundingClientRect().width + 12 : 160;
      track.scrollBy({ left: step * Number(arrow.dataset.gcScroll), behavior: 'smooth' });
      return;
    }

    // Links naar de winkelwagen openen de lade (behalve op de winkelwagenpagina zelf)
    var link = t.closest('a[href]');
    if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey && drawer() && !drawer().contains(link)) {
      var path = link.pathname.replace(/\/$/, '');
      var cartPath = (root + 'cart').replace(/\/$/, '');
      if ((path === cartPath || path === '/cart') && link.host === window.location.host && !/\/cart\/?$/.test(window.location.pathname)) {
        e.preventDefault();
        open();
      }
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-gc-qty-input]');
    if (!input) return;
    var line = input.closest('[data-gc-line]');
    var value = parseInt(input.value, 10);
    if (!isNaN(value)) changeLine(line.dataset.gcLine, value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer() && drawer().hasAttribute('open')) close();
    if (e.key === 'Tab' && drawer() && drawer().hasAttribute('open')) trapFocus(e);
  });

  function trapFocus(e) {
    var panel = drawer().querySelector('.gc__panel');
    var nodes = panel.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])');
    var list = Array.prototype.filter.call(nodes, function (n) { return n.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // "In winkelwagen"-formulieren: in de capture-fase, zodat het product-form van het thema niet ook toevoegt
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute || !isCartAddUrl(form.getAttribute('action') || '')) return;
    if (form.hasAttribute('data-gc-ignore')) return;
    e.preventDefault();
    e.stopPropagation();

    var button = e.submitter || form.querySelector('[type="submit"]');
    if (button && button.classList.contains('loading')) return;
    var host = form.closest('product-form');
    var errorBox = host && host.querySelector('.product-form__error-container');
    var errorText = errorBox && errorBox.querySelector('.product-form__error-message');
    if (errorBox) errorBox.hidden = true;
    if (button) { button.classList.add('loading'); button.setAttribute('aria-disabled', 'true'); }

    var body = new FormData(form);
    // Snel toevoegen: de variant zit op de aangeklikte maatknop (name="id")
    if (button && button.name === 'id' && button.value) body.set('id', button.value);

    request('cart/add.js', withSections(body))
      .then(function (item) {
        render(item.sections && item.sections[SECTION]);
        publishUpdate(item);
        var gq = form.closest('[data-gq]');
        if (gq) closeQuickAdd(gq);
        open();
      })
      .catch(function (err) {
        if (errorBox && errorText) { errorText.textContent = err.message; errorBox.hidden = false; }
        else { open(); showError(err.message); }
      })
      .finally(function () {
        if (button) { button.classList.remove('loading'); button.removeAttribute('aria-disabled'); }
      });
  }, true);

  // Wijzigingen door andere scripts (PageFly, shop the look, apps) bijhouden
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var mine = internal > 0;
      return nativeFetch.apply(this, arguments).then(function (res) {
        if (!mine && res.ok && isCartChangeUrl(url)) scheduleRefresh(isCartAddUrl(url));
        return res;
      });
    };
  }
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._gcUrl = String(url || '');
    return xhrOpen.apply(this, arguments);
  };
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (isCartChangeUrl(xhr._gcUrl)) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) scheduleRefresh(isCartAddUrl(xhr._gcUrl));
      });
    }
    return xhrSend.apply(this, arguments);
  };

  // Na terug-navigeren (bfcache) kan de wagen veranderd zijn
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.GentsyCart = { open: open, close: close, refresh: refresh };
  // Bestaande code (o.a. shop the look) roept deze namen van de oude app aan
  window.SLIDECART_OPEN = open;
  window.SLIDECART_CLOSE = close;
  window.SLIDECART_UPDATE = refresh;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupContent);
  else setupContent();
})();
